import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import { IncomingMessage } from 'http';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [{ newName: 'site_wide_promo', oldNameMatcher: /^site_wide_promo/m }],
  });
};
